import './chunk-VJY7NXNQ.mjs';
import { withLinks } from './chunk-DXNAW7Q2.mjs';
import './chunk-JT3VIYBO.mjs';

var decorators=[withLinks];

export { decorators };
